import React, { FC, useContext } from "react";
import { TenantContext } from "v3/context/tenant";
import { SavedOption } from "v3/components/checkout/SavedOption";
import { StyledBalance } from "./index.styled";

interface AllocationOptionProps {
  balance: string;
  checked: boolean;
  isDefault: boolean;
  onSelect: () => void;
  isDisabled?: boolean;
}

// Only tz uses this component. Will need to be refactored if more shops add allocations.
export const AllocationOption: FC<AllocationOptionProps> = ({
  balance,
  checked = false,
  isDefault = false,
  onSelect,
  isDisabled,
}) => {
  const { logoSmall } = useContext(TenantContext);

  return (
    <SavedOption
      checked={checked}
      handleClick={onSelect}
      imageSrc={logoSmall?.src}
      imageAlt={logoSmall?.alt || "Allocation"}
      isDefault={isDefault}
      showTenantLogo
      isDisabled={isDisabled}
      title="Pay with allocation"
    >
      <StyledBalance>Balance: {balance}</StyledBalance>
    </SavedOption>
  );
};
